import { Box, Typography } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import { ContainerSchema } from "../types/container.type";

const LOGO_SRC = "https://recyclee.io/assets/images/image15.png";

interface Props {
  container: ContainerSchema;
}

export const ContainerQRPrint: React.FC<Props> = ({ container }) => {
  const containerId = container.id;
  const materialName =
    container.material_type?.name || container.material_type_id || "N/A";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        p: 3,
        color: "#000",

        /* ===== SCREEN STYLE ===== */
        backgroundColor: "#ffffff",
        borderRadius: 2,
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",

        /* ===== PRINT STYLE ===== */
        "@media print": {
          backgroundColor: "#fff",
          boxShadow: "none",
          borderRadius: 0,
          padding: 0,
          gap: 1.5,
        },
      }}
    >
      {/* LOGO */}
      <Box
        component="img"
        src={LOGO_SRC}
        alt="RECYCLEE"
        sx={{
          height: 48,
          mb: 1,
          objectFit: "contain",

          "@media print": {
            height: 56,
            marginBottom: 0.5,
          },
        }}
      />

      {/* SCREEN QR */}
      <Box
        sx={{
          display: "block",
          "@media print": {
            display: "none",
          },
        }}
      >
        <QRCodeCanvas
          value={containerId}
          size={360}
          level="H"
          includeMargin
          style={{ borderRadius: 10 }}
        />
      </Box>

      {/* PRINT QR */}
      <Box
        sx={{
          display: "none",
          "@media print": {
            display: "block",
          },
        }}
      >
        <QRCodeCanvas
          value={containerId}
          size={650}
          level="H"
          includeMargin
        />
      </Box>

      {/* CONTAINER ID */}
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 700,

          "@media print": {
            fontSize: 18,
          },
        }}
      >
        Container ID
      </Typography>

      <Typography
        sx={{
          fontSize: 20,
          fontWeight: 800,
          wordBreak: "break-all",
          textAlign: "center",

          "@media print": {
            fontSize: 24,
          },
        }}
      >
        {containerId}
      </Typography>

      {/* MATERIAL TYPE */}
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 700,
          mt: 1,

          "@media print": {
            fontSize: 18,
            mt: 0.5,
          },
        }}
      >
        Material Type
      </Typography>

      <Typography
        sx={{
          fontSize: 18,
          fontWeight: 800,

          "@media print": {
            fontSize: 22,
          },
        }}
      >
        {materialName}
      </Typography>
    </Box>
  );
};
